import axios from "axios";

const resolveBaseUrl = (provided) => provided || process.env.REACT_APP_CLM_API_BASE_URL;


export const createSubscriptionService = (baseUrl) => {
	const API_BASE_URL = resolveBaseUrl(baseUrl);
  	const axiosInstance = axios.create({
    	baseURL: API_BASE_URL,
    	timeout: 15000,
  	});

  	async function fetchProducts(params = {}) {
    	try {
      		const resp = await axiosInstance.get('cms/report/product/list', { params });
      		return resp;
    	} catch (err) {
      		return null;
    	}
  	}

  	async function fetchPlans(product_id) {
		const url = product_id ? `cms/report/subscription/list/${product_id}` : 'cms/report/subscription/list';
    	try {
      		const resp = await axiosInstance.get(url);
      		return resp;
    	} catch (err) {
      		return null;
    	}
  	}

  	async function fetchMetrics(params = {}) {
    	try {
      		const resp = await axiosInstance.get('cms/report/subscription/count-metrics', { params });
      		return resp;
    	} catch (err) {
      		return null;
    	}
  	}

	async function fetchTransactions(params = {}) {
    	try {
      		const resp = await axiosInstance.get('cms/report/subscription/transactions', { params });
      		return resp;
    	} catch (err) {
      		return null;
    	}
  	}

	async function exportTransactions(params = {}) {
    	try {
      		const resp = await axiosInstance.get('cms/report/subscription/export/transactions', { params });
      		return resp;
    	} catch (err) {
      		return null;
    	}
  	}

  	return {
    	fetchProducts,
    	fetchPlans,
    	fetchMetrics,
		fetchTransactions,
		exportTransactions
  	};
};

// Default export: ready-to-use instance using env or fallback
const SubscriptionService = createSubscriptionService();
export default SubscriptionService;
